import React, { useState, useEffect } from 'react';
import { Card, Progress, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import './MachineStatus.css'; // Import the CSS file
import AppHeader from './Header'; // Import the shared header component
import './Borrow.css'; // Import the CSS file

const { Title } = Typography;

const machineNames = {
    1: '博雅 Boya',
    2: '普通 Putong',
    3: '新生 Xinsheng',
    4: '共同 Gongtong',
    5: '綜合 Zonghe',
    6: '機台六 Machine 6'
};

const MachineStatus = () => {
    const [machines, setMachines] = useState([]);
    const [userName, setUserName] = useState(sessionStorage.getItem('name'));
    const navigate = useNavigate();
   
    const handleLogout = () => {
        sessionStorage.clear();
        setUserName(null);
        navigate('/login');
    };

    useEffect(() => {
        fetchMachines();
    }, []);

    const fetchMachines = async () => {
        try {
            const response = await fetch('https://54.178.141.189/machines'); // Adjust the endpoint as needed
            const data = await response.json();
            setMachines(data);
        } catch (error) {
            console.error('Error fetching machine data:', error);
        }
    };

    return (
        <div>
            <AppHeader userName={userName} handleLogout={handleLogout} />
            <div className="borrow-container">
                <div style={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'flex-start', height: '100vh' }}>
                    <div className="content-container-app">
                    <Title level={1} style={{ fontFamily: 'Normal', fontSize: '2.5rem', fontWeight: 'bold', textAlign: 'center' , marginBottom:"0rem"}}>臺大循環餐盒系統試辦計畫</Title>
                    <p style={{ fontFamily: 'Normal', fontSize: '2rem', fontWeight: 'bold', textAlign: 'center', marginTop: '0rem' }}>NTU ECOntainer Pilot Program</p>
                        <img src="/eco-packaging.png" alt="Logo" style={{ width: '25%'}} />
                        <Title style={{marginBottom:"0rem"}}level={2} className="sub-title">歸還站點</Title>
                        <p style={{ fontFamily: 'Normal', fontSize: '2rem', fontWeight: 'bold', textAlign: 'center', marginTop: '0rem' }}>Return Location</p>
                        <div className="machine-cards">
                            {machines.slice(0, 5).map((machine) => { // Only render the first 5 machines
                                const machineIdInt = parseInt(machine.machineId.replace('machine', ''), 10);
                                return (
                                    <Card key={machine.machineId} title={`${machineNames[machineIdInt] || machine.machineId}`} className="machine-card">
                                        {machineIdInt === 1 || machineIdInt === 5 ? (
                                            <p>暫停服務 out of service！</p>
                                        ) : (
                                            <>
                                                <p>餐盒 Box: {machine.currentAmount}/15</p>
                                                <Progress 
                                                    percent={Math.floor(machine.currentAmount / 15 * 100)}
                                                    status={machine.currentAmount > 15 ? 'exception' : 'normal'}
                                                />
                                            </>
                                        )}
                                    </Card>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MachineStatus;